import { configureStore } from "@reduxjs/toolkit";
import scoutingActiveTabSlice from "./feature/scoutingActiveTabSlice";

export const store = configureStore({
  reducer: {
    scoutingActiveTab: scoutingActiveTabSlice,
  },
});
